import { render, staticRenderFns } from "./Company2modul.vue?vue&type=template&id=7f57604b&"
import script from "./Company2modul.vue?vue&type=script&lang=js&"
export * from "./Company2modul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports